"use strict";

module.exports = {
  'name': 'NaN',
  'category': 'Constants',
  'syntax': ['NaN'],
  'description': 'Not a number',
  'examples': ['NaN', '0 / 0'],
  'seealso': []
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/constants/NaN.js
// module id = 790
// module chunks = 0